import React, { useState, useEffect, useRef, useMemo } from 'react';
import { notify } from 'react-notify-toast';
import { useHistory } from 'react-router-dom';
import {
  Spinner,
  Row,
  Col,
  Container,
  Card,
  Button,
  InputGroup,
  Form,
  Tabs,
  Tab,
  Table,
  OverlayTrigger,
  Tooltip as BSTooltip,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarAlt,
  faFilter,
  faRedoAlt,
  faFileExcel,
  faCreditCard,
  faLayerGroup,
  faGraduationCap,
  faDollarSign,
  faMoneyBillWave,
  faReceipt,
  faChartLine,
  faChartBar,
  faFileInvoiceDollar,
} from '@fortawesome/free-solid-svg-icons';
import Axios from 'axios';
import clientAxios from '../../clients/clientAxios';
import {
  ResponsiveContainer,
  BarChart,
  AreaChart,
  Area,
  Brush,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from 'recharts';
import moment from 'moment';
import {
  calculateAveragePerMonth,
  calculateDollarSalesPerMonth,
  convertToArray,
  convertToDollars,
  convertHistoricDataToDollars,
} from '../../clients/helpers/conversionToDollars';
import LoadingScreen from '../../Layout/LoadingScreen';
import IcomesModal from './IcomesModal';
import { handleExportExcel } from '../../helpers/exportExcelIncomes';
import { DISPLAY_TYPES, EXPORT_OPTIONS, PRESET_MONTHS_BACK, BUTTON_VARIANTS } from '../../constants';
import { getTrimmedGraphicData, getTrimmedGraphicDataEndIndex } from './statisticsUtils';
import { getIncomeHistory, getIncomeGraphic } from '../../services/billsService';
import PendingCollections from './PendingCollections';
import './incomesTabs.css';
export default function Incomes() {
  const history = useHistory();
  let momentStartYear = moment().startOf('year').format('YYYY-MM-DD');
  let momentEndYear = moment().endOf('year').format('YYYY-MM-DD');
  const [since, setSince] = useState(momentStartYear);
  const [to, setTo] = useState(momentEndYear);
  const [payment, setPayment] = useState('');
  const [year, setYear] = useState(moment().format('YYYY'));
  const [years, setYears] = useState([]);
  const [display, setDisplay] = useState(DISPLAY_TYPES.ANUAL);
  const [scolarship, setScolarship] = useState(false);
  const [graphicData, setGraphicData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState({ fetch: true, form: true });
  const [isLoadingYears, setIsLoadingYears] = useState(true);
  const [yearly, setYearly] = useState([]);
  const [sixm, setSixm] = useState([]);
  const [historic, setHistoric] = useState([]);
  const [isDollar, setisDollar] = useState(false);
  const [prevData, setPrevData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [exportOption, setExportOption] = useState(EXPORT_OPTIONS.CURRENT);
  const usdCacheRef = useRef({});
  const [activeTab, setActiveTab] = useState('chart');
  const [availableYears, setAvailableYears] = useState([]);
  const [year1, setYear1] = useState(moment().year() - 1);
  const [year2, setYear2] = useState(moment().year());
  const [comparisonData, setComparisonData] = useState(null);
  const [comparisonLoading, setComparisonLoading] = useState(false);
  const [brushRange, setBrushRange] = useState({ startIndex: 0, endIndex: undefined });
  const [historicPreset, setHistoricPreset] = useState('all');
  const [formatCurrency, setformatCurrency] = useState(
    new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })
  );
  let counter = 0;
  useEffect(() => {
    if (counter === 0) {
      fetchData();
      ++counter;
      buildYearsOptions();
    }
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (years.length > 0 && availableYears.length === 0) {
      fetchAvailableYears();
    }
    //eslint-disable-next-line
  }, [years]);
  useEffect(() => {
    setIsLoading((state) => ({ ...state, form: true }));
    fetchData();
    //eslint-disable-next-line
  }, [since, to, payment, year, display, scolarship]);
  useEffect(() => {
    if (
      yearly.length !== 0 ||
      sixm.length !== 0 ||
      historic.length !== 0
    ) {
      yearDates();
    }
    //eslint-disable-next-line
  }, [yearly, sixm, historic]);

  const fetchData = async () => {
    if (display === DISPLAY_TYPES.HISTORIC || display === DISPLAY_TYPES.SPECIFIC) {
      try {
        const data = await getIncomeHistory({ since, to, payment });
        const records = data?.data || [];
        setFetchedData(records);
        setIsLoading((state) => ({ ...state, fetch: false }));
        setYearly([]);
        setSixm([]);
        setHistoric(records);
      } catch (err) {
        notify.show(err.response?.data?.message || 'Error al cargar datos', 'error');
        setIsLoading((state) => ({ ...state, fetch: false }));
      }
      return;
    }

    try {
      const data = await getIncomeGraphic({ since, to, payment, year, display });
      const monthlyData = data?.data || [];
      const hasData =
        display === DISPLAY_TYPES.ANUAL
          ? monthlyData.some((month) => month.IngresosTotales > 0)
          : monthlyData.length > 0;
      setFetchedData(hasData ? monthlyData : []);
      if (display === DISPLAY_TYPES.SIX_MONTHS && monthlyData.length > 0) {
        setisDollar(false);
      }
      setIsLoading((state) => ({ ...state, fetch: false }));
      setYearly(display === DISPLAY_TYPES.ANUAL ? monthlyData : []);
      setSixm(display === DISPLAY_TYPES.SIX_MONTHS ? monthlyData : []);
      setHistoric([]);
    } catch (error) {
      notify.show(error.response?.data?.message, 'error');
      history.push('/');
    }
  };

  const clearSearch = () => {
    setSince(momentStartYear);
    setTo(momentEndYear);
    setPayment('');
    setYear(moment().format('YYYY'));
    setDisplay(DISPLAY_TYPES.ANUAL);
    setisDollar(false);
    setScolarship(false);
    setHistoricPreset('all');
  };

  const yearDates = () => {
    let dataLet = [];
    let monthsLong = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    let monthsShort = [
      'Ene',
      'Feb',
      'Mar',
      'Abr',
      'May',
      'Jun',
      'Jul',
      'Ago',
      'Sep',
      'Oct',
      'Nov',
      'Dic',
    ];

    if (display === DISPLAY_TYPES.ANUAL) {
      for (let i = 0; i < 12; i++) {
        let plusAmounthForScolarship = 0;
        if (
          year === '2022' &&
          scolarship &&
          window.location.href.includes('admin.rollingcodeschool.com') &&
          (i === 10 || i === 11)
        ) {
          plusAmounthForScolarship = 8675458;
        }
        if (
          year === '2023' &&
          scolarship &&
          window.location.href.includes('admin.rollingcodeschool.com') &&
          i === 5
        ) {
          plusAmounthForScolarship = 2090196 + 1110800;
        }
        if (
          year === '2023' &&
          scolarship &&
          window.location.href.includes('admin.rollingcodeschool.com') &&
          i === 9
        ) {
          plusAmounthForScolarship = 19342915;
        }
        const c1Val = (yearly[i]?.cuota1 || 0) + plusAmounthForScolarship;
        const ocVal = yearly[i]?.otrasCuotas || 0;
        const totVal = c1Val + ocVal;
        dataLet.push({
          name: monthsShort[i],
          fullName: `${monthsLong[i]} ${year}`,
          month: monthsLong[i],
          year: year,
          monthIndex: i,
          Cuota1: c1Val,
          OtrasCuotas: ocVal,
          Total: totVal,
          firstInstallmentPercentage: yearly[i]?.firstInstallmentPercentage || 0,
          otherInstallmentsPercentage: yearly[i]?.otherInstallmentsPercentage || 0,
        });
      }
      if (payment !== '') {
        let abc = graphicData.filter((i) => i.Total.length !== 0);
        if (abc.length === 0) {
          dataLet = [];
        }
      }
    } else if (display === DISPLAY_TYPES.HISTORIC || display === DISPLAY_TYPES.SPECIFIC) {
      const currentYearNum = parseInt(moment().format('YYYY'));
      const currentMonthNum = parseInt(moment().format('M')) - 1;
      const startMoment = display === DISPLAY_TYPES.SPECIFIC ? moment(since).startOf('month') : null;
      const endMoment = display === DISPLAY_TYPES.SPECIFIC ? moment(to).endOf('month') : null;

      (historic || []).forEach((item) => {
        const itemYearNum = parseInt(item.year);
        const itemDate = moment(`${item.year}-${String(item.monthIndex + 1).padStart(2, '0')}-01`);

        if (display === DISPLAY_TYPES.SPECIFIC && startMoment && endMoment) {
          if (!itemDate.isBetween(startMoment, endMoment, null, '[]')) {
            return;
          }
        } else if (display === DISPLAY_TYPES.HISTORIC) {
          if (
            itemYearNum > currentYearNum ||
            (itemYearNum === currentYearNum && item.monthIndex > currentMonthNum)
          ) {
            if ((item.cuota1 || 0) === 0 && (item.otrasCuotas || 0) === 0) {
              return;
            }
          }
        }

        let plusAmounthForScolarship = 0;
        if (
          item.year === '2022' &&
          scolarship &&
          window.location.href.includes('admin.rollingcodeschool.com') &&
          (item.monthIndex === 10 || item.monthIndex === 11)
        ) {
          plusAmounthForScolarship = 8675458;
        }
        if (
          item.year === '2023' &&
          scolarship &&
          window.location.href.includes('admin.rollingcodeschool.com') &&
          item.monthIndex === 5
        ) {
          plusAmounthForScolarship = 2090196 + 1110800;
        }
        if (
          item.year === '2023' &&
          scolarship &&
          window.location.href.includes('admin.rollingcodeschool.com') &&
          item.monthIndex === 9
        ) {
          plusAmounthForScolarship = 19342915;
        }

        const cuota1Val = (item.cuota1 || 0) + plusAmounthForScolarship;
        const otrasVal = item.otrasCuotas || 0;
        const totalVal = cuota1Val + otrasVal;

        dataLet.push({
          name: `${monthsShort[item.monthIndex]} '${String(item.year).slice(-2)}`,
          fullName: `${monthsLong[item.monthIndex]} ${item.year}`,
          month: monthsLong[item.monthIndex],
          year: item.year,
          monthIndex: item.monthIndex,
          Cuota1: cuota1Val,
          OtrasCuotas: otrasVal,
          Total: totalVal,
          firstInstallmentPercentage: item.firstInstallmentPercentage || 0,
          otherInstallmentsPercentage: item.otherInstallmentsPercentage || 0,
        });
      });
    } else if (display === DISPLAY_TYPES.SIX_MONTHS) {
      for (let i = 0; i < 6; i++) {
        let dataInside = {
          name: monthsShort[sixm[i]?.month ?? 0],
          fullName: `${monthsLong[sixm[i]?.month ?? 0]}`,
          Total: sixm[i]?.result?.IngresosTotales || 0,
        };
        dataLet.push(dataInside);
      }
    }

    setGraphicData(dataLet);
    if ((display === DISPLAY_TYPES.HISTORIC || display === DISPLAY_TYPES.SPECIFIC) && dataLet.length > 0) {
      setBrushRange({ startIndex: 0, endIndex: dataLet.length - 1 });
    }
    setIsLoading((state) => ({ ...state, form: false }));
  };

  const handlePresetRange = (preset) => {
    setHistoricPreset(preset);
    const now = moment();
    const monthsBack = PRESET_MONTHS_BACK[preset];
    if (Number.isInteger(monthsBack)) {
      setSince(now.clone().subtract(monthsBack, 'months').startOf('month').format('YYYY-MM-DD'));
      setTo(now.format('YYYY-MM-DD'));
      return;
    }
    setSince('2020-01-01');
    setTo(now.format('YYYY-MM-DD'));
  };

  const handleYearPreset = (event) => {
    const year = Number(event.currentTarget.dataset.year);
    setHistoricPreset(year);
    setSince(moment().year(year).startOf('year').format('YYYY-MM-DD'));
    setTo(moment().year(year).endOf('year').format('YYYY-MM-DD'));
  };

  const handleBrushChange = ({ startIndex, endIndex }) => {
    if (!Number.isInteger(startIndex) || !Number.isInteger(endIndex)) return;
    setBrushRange((prev) => ({
      startIndex: prev.startIndex + startIndex,
      endIndex: prev.startIndex + endIndex,
    }));
  };

  const getDollarPrice = async () => {
    const key =
      display === DISPLAY_TYPES.SIX_MONTHS
        ? `sixm:${moment()
          .subtract(6, 'months')
          .startOf('month')
          .format('YYYY-MM')}-${moment().format('YYYY-MM')}`
        : display === DISPLAY_TYPES.HISTORIC
        ? `historic:${payment}:${scolarship}`
        : `annual:${year}`;

    const applyConversion = (equalArray) => {
      const copyData = [...graphicData];
      setPrevData(copyData);
      const resultConversion = convertToDollars(equalArray, copyData);

      if (display === DISPLAY_TYPES.SIX_MONTHS) {
        const sortedGraphicData = copyData.map((item) => {
          const convertedItem = resultConversion.find(
            (d) => d.name === item.name
          );
          return convertedItem ? convertedItem : item;
        });
        setGraphicData(sortedGraphicData);
      } else {
        setGraphicData(resultConversion);
      }
    };

    const cached = usdCacheRef.current[key];
    if (cached) {
      if (display === DISPLAY_TYPES.HISTORIC) {
        setPrevData([...graphicData]);
        setGraphicData(cached);
        return;
      }
      applyConversion(cached);
      return;
    }
    setIsLoading((s) => ({ ...s, form: true }));
    try {
      let momentStartYear, momentEndYear;
      if (display === DISPLAY_TYPES.SIX_MONTHS) {
        const sixMonthsAgo = moment().subtract(6, 'months');
        momentStartYear = sixMonthsAgo.startOf('month').format('DD-MM-YYYY');
        momentEndYear = moment().format('DD-MM-YYYY');
      } else if (display === DISPLAY_TYPES.HISTORIC) {
        momentStartYear = '01-01-2020';
        momentEndYear = moment().format('DD-MM-YYYY');
      } else {
        momentStartYear = moment().year(year).startOf('year').format('DD-MM-YYYY');
        momentEndYear = moment().year(year).endOf('year').format('DD-MM-YYYY');
      }
      const { data } = await Axios(
        `https://mercados.ambito.com//dolar/informal/historico-general/${momentStartYear}/${momentEndYear}`
      );

      if (display === DISPLAY_TYPES.HISTORIC) {
        const copyGraphicData = [...graphicData];
        setPrevData(copyGraphicData);
        const convertedGraphicData = convertHistoricDataToDollars(data, copyGraphicData);

        usdCacheRef.current[key] = convertedGraphicData;
        setGraphicData(convertedGraphicData);
        return;
      }

      const totalDollarsPerMonth = calculateDollarSalesPerMonth(data);
      const average = calculateAveragePerMonth(totalDollarsPerMonth);
      const equalArray = convertToArray(average);
      usdCacheRef.current[key] = equalArray;
      applyConversion(equalArray);
    } catch {
      notify.show(
        'No se pudo acceder a los datos para realizar la conversión, intente de nuevo más tarde',
        'error'
      );
    } finally {
      setIsLoading((state) => ({ ...state, form: false }));
    }
  };
  useEffect(() => {
    if (isDollar) {
      getDollarPrice();
      setformatCurrency(
        new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
      );
    } else {
      if (prevData) setGraphicData(prevData);
      setformatCurrency(
        new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDollar]);
  const buildYearsOptions = () => {
    var currentYear = parseInt(moment().format('YYYY'));
    var quantityOfYears = currentYear - 2020;
    let quantityOfYearsSelect = [];
    for (let q = 0; q <= quantityOfYears; q++) {
      quantityOfYearsSelect.push(`${q < 10 ? '202' + q : '20' + (q + 20)}`);
    }
    setYears(quantityOfYearsSelect);
    setIsLoadingYears(false);
    setYear(moment().format('YYYY'));
  };
  const fetchAvailableYears = () => {
    clientAxios.get('/bills/available-years')
      .then(({ data }) => {
        setAvailableYears(data);
        if (data.length >= 2) {
          setYear1(parseInt(data[data.length - 2]));
          setYear2(parseInt(data[data.length - 1]));
        }
      })
      .catch((err) => {
        const yearsAsNumbers = years.map(y => parseInt(y));
        setAvailableYears(yearsAsNumbers);
        if (yearsAsNumbers.length >= 2) {
          setYear1(yearsAsNumbers[yearsAsNumbers.length - 2]);
          setYear2(yearsAsNumbers[yearsAsNumbers.length - 1]);
        }
      });
  };
  const fetchComparisonData = () => {
    if (year1 === year2) {
      notify.show('Debe seleccionar años diferentes', 'error');
      return;
    }
    setComparisonLoading(true);
    const payload = { year1, year2 };
    clientAxios.post('/graph/report-average-sale', payload, {
      headers: {
        'auth-token': localStorage.getItem('JWT')
      }
    })
      .then(({ data }) => {
        if (data.success && data.data && data.data.comparison) {
          setComparisonData(data.data.comparison);
        } else {
          setComparisonData(null);
          notify.show('No se encontraron datos de comparación', 'warning');
        }
      })
      .catch((err) => {
        notify.show(err.response?.data?.message || 'Error al obtener comparativa', 'error');
      })
      .finally(() => {
        setComparisonLoading(false);
      });
  };
  const formatCompactCurrency = (value) => {
    if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
      return `$${(value / 1000).toFixed(0)}k`;
    }
    return '$' + value.toLocaleString();
  };
  const formatCurrencyARS = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
  });
  const summaryMetrics = useMemo(() => {
    if (!graphicData || graphicData.length === 0) {
      return {
        totalIncome: 0,
        cuota1Total: 0,
        otrasCuotasTotal: 0,
        averageTicket: 0,
        cuota1Percentage: '0',
        otrasCuotasPercentage: '0',
        peakMonth: null,
        activePeriodsCount: 0,
      };
    }

    let total = 0;
    let cuota1Sum = 0;
    let otrasSum = 0;
    let maxIncome = -1;
    let peak = null;
    let activePeriodsCount = 0;

    graphicData.forEach((item) => {
      const c1 = Number(item.Cuota1) || 0;
      const oc = Number(item.OtrasCuotas) || 0;
      const itemTotal = item.Total !== undefined ? Number(item.Total) : c1 + oc;

      total += itemTotal;
      cuota1Sum += c1;
      otrasSum += oc;

      if (itemTotal > 0) {
        activePeriodsCount += 1;
      }

      if (itemTotal > maxIncome) {
        maxIncome = itemTotal;
        peak = { name: item.name, amount: itemTotal };
      }
    });

    const avgTicket = activePeriodsCount > 0 ? total / activePeriodsCount : 0;
    const c1Pct = total > 0 ? ((cuota1Sum / total) * 100).toFixed(1) : '0';
    const ocPct = total > 0 ? ((otrasSum / total) * 100).toFixed(1) : '0';

    return {
      totalIncome: total,
      cuota1Total: cuota1Sum,
      otrasCuotasTotal: otrasSum,
      averageTicket: avgTicket,
      cuota1Percentage: c1Pct,
      otrasCuotasPercentage: ocPct,
      peakMonth: peak,
      activePeriodsCount,
    };
  }, [graphicData]);

  const renderCustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null;
    const cuota1 =
      payload.find((p) => p.dataKey === 'Cuota1' || p.name === 'Cuota 1')?.value ?? 0;
    const otras =
      payload.find((p) => p.dataKey === 'OtrasCuotas' || p.name === 'Otras cuotas')?.value ?? 0;
    const isMultiCategory =
      display === DISPLAY_TYPES.ANUAL || display === DISPLAY_TYPES.HISTORIC;
    const total = isMultiCategory
      ? cuota1 + otras
      : (payload.find((p) => p.dataKey === 'Total' || p.name === 'Total')?.value ?? (cuota1 + otras));
    const averageMonth = payload[0]?.payload?.averageMonth;
    const tooltipTitle = payload[0]?.payload?.fullName || label;
    const firstInstallmentPercentage =
      payload[0]?.payload?.firstInstallmentPercentage ??
      (total > 0 ? ((cuota1 / total) * 100).toFixed(1) : 0);
    const otherInstallmentsPercentage =
      payload[0]?.payload?.otherInstallmentsPercentage ??
      (total > 0 ? ((otras / total) * 100).toFixed(1) : 0);

    return (
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          padding: '14px 18px',
          boxShadow:
            '0 12px 28px -4px rgba(0, 0, 0, 0.15), 0 6px 12px -3px rgba(0, 0, 0, 0.08)',
          border: '1px solid #e2e8f0',
          minWidth: '220px',
        }}
      >
        <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
          <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '14px' }}>
            {tooltipTitle}
          </span>
          <span
            className="badge badge-light text-muted border px-2 py-1"
            style={{ fontSize: '11px' }}
          >
            {isDollar ? 'USD' : 'ARS'}
          </span>
        </div>

        {isMultiCategory && (
          <>
            <div
              className="d-flex align-items-center justify-content-between my-1"
              style={{ fontSize: '13px' }}
            >
              <span className="d-flex align-items-center text-muted">
                <span
                  style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: '#10B981',
                    display: 'inline-block',
                    marginRight: '6px',
                  }}
                />
                Cuota 1:
              </span>
              <span style={{ fontWeight: 600, color: '#0f172a' }}>
                {formatCurrency.format(cuota1)}{' '}
                <small className="text-muted">({firstInstallmentPercentage}%)</small>
              </span>
            </div>

            <div
              className="d-flex align-items-center justify-content-between my-1"
              style={{ fontSize: '13px' }}
            >
              <span className="d-flex align-items-center text-muted">
                <span
                  style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: '#6366F1',
                    display: 'inline-block',
                    marginRight: '6px',
                  }}
                />
                Otras cuotas:
              </span>
              <span style={{ fontWeight: 600, color: '#0f172a' }}>
                {formatCurrency.format(otras)}{' '}
                <small className="text-muted">({otherInstallmentsPercentage}%)</small>
              </span>
            </div>
          </>
        )}

        <div
          className="d-flex align-items-center justify-content-between mt-2 pt-2 border-top"
          style={{ fontSize: '13px' }}
        >
          <span style={{ fontWeight: 600, color: '#334155' }}>Total:</span>
          <span style={{ fontWeight: 700, color: '#059669', fontSize: '14px' }}>
            {formatCurrency.format(total)}
          </span>
        </div>

        {isDollar && averageMonth && (
          <div className="mt-2 pt-1 border-top text-muted small">
            Cambio Promedio: <strong>${averageMonth} ARS</strong>
          </div>
        )}
      </div>
    );
  };
  const getTrendIndicator = (percentage) => {
    if (percentage > 0) {
      return <span style={{ color: '#28a745' }}>↑ {percentage.toFixed(1)}%</span>;
    } else if (percentage < 0) {
      return <span style={{ color: '#dc3545' }}>↓ {Math.abs(percentage).toFixed(1)}%</span>;
    }
    return <span style={{ color: '#6c757d' }}>= 0%</span>;
  };
  const renderComparativaVentas = () => (
    <Container className="mb-5 pl-0 pr-0">
      <Container className="bg-light rounded shadow p-3 pl-0 mb-5">
        <h3 style={{ color: '#1757b8ff', fontSize: '1.2rem' }}>Reporte de Ventas Importe Promedio</h3>
        <Form>
          <Row className="mb-2">
            <Col>
              <Form.Group className="my-auto">
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>Año de Referencia</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    as="select"
                    value={year1}
                    onChange={(e) => setYear1(parseInt(e.target.value))}
                  >
                    {availableYears.length === 0 ? (
                      <option>Cargando años...</option>
                    ) : (
                      availableYears.map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))
                    )}
                  </Form.Control>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="my-auto">
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>Año a Comparar</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    as="select"
                    value={year2}
                    onChange={(e) => setYear2(parseInt(e.target.value))}
                  >
                    {availableYears.length === 0 ? (
                      <option>Cargando años...</option>
                    ) : (
                      availableYears.map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))
                    )}
                  </Form.Control>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={2}>
              <Button onClick={fetchComparisonData} disabled={comparisonLoading}>
                {comparisonLoading ? 'Cargando...' : 'Comparar'}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
      {comparisonLoading ? (
        <LoadingScreen />
      ) : comparisonData && Array.isArray(comparisonData) ? (
        <Row className="container d-flex bg-light rounded shadow p-3 ml-0 mr-0">
          <Col>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Periodo</th>
                  <th>Año {year1}</th>
                  <th>Año {year1} - Ajustado por inflación</th>
                  <th>Año {year2}</th>
                  <th>Año {year2} - Ajustado por inflación</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((monthData, index) => {
                  const growthPercentage =
                    ((monthData.year2AdjustedIncome - monthData.year1AdjustedIncome) /
                      monthData.year1AdjustedIncome) * 100;
                  return (
                    <tr key={index}>
                      <td>{monthData.monthName}</td>
                      <td>{formatCurrencyARS.format(monthData.year1Income)}</td>
                      <td>{formatCurrencyARS.format(monthData.year1AdjustedIncome)}</td>
                      <td>{formatCurrencyARS.format(monthData.year2Income)}</td>
                      <td>
                        {formatCurrencyARS.format(monthData.year2AdjustedIncome)}
                        <div style={{ marginTop: '4px' }}>
                          {getTrendIndicator(growthPercentage)}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
      ) : comparisonData ? (
        <Row className="container d-flex bg-light rounded shadow p-3 align-items-center ml-0 mr-0">
          <Col className="d-flex justify-content-center text-danger">
            Error: Formato de datos incorrecto. Verifique la respuesta de la API.
          </Col>
        </Row>
      ) : (
        <Row className="container d-flex bg-light rounded shadow p-3 align-items-center ml-0 mr-0">
          <Col className="d-flex justify-content-center text-muted">
            Seleccione los años y haga clic en "Comparar" para ver la comparativa
          </Col>
        </Row>
      )}
    </Container>
  );
  if (isLoading.fetch) {
    return <LoadingScreen />;
  } else if (isLoading.fetch === false) {
    return (
      <>
        <div className="incomes-tabs-wrapper">
          <Tabs activeKey={activeTab} onSelect={(selectedKey) => setActiveTab(selectedKey)} className="incomes-tabs mb-3">
            <Tab
              eventKey="chart"
              title={
                <span className="incomes-tabs-tab-title">
                  <FontAwesomeIcon icon={faChartBar} className="incomes-tabs-tab-icon" />
                  Gráfico de Ingresos
                </span>
              }
            >
            <IcomesModal
              show={showModal}
              onHide={() => setShowModal(false)}
              exportOption={exportOption}
              setExportOption={setExportOption}
              onConfirm={() => {
                setShowModal(false);
                handleExportExcel({
                  exportOption,
                  display,
                  payment,
                  year,
                  since,
                  to,
                  JWT: localStorage.getItem('JWT'),
                });
              }}
            />
            <Container fluid className="px-0 mb-4">
              <Card className="border-0 shadow-sm rounded-lg bg-white overflow-hidden">
                <div className="bg-light px-4 py-3 border-bottom d-flex flex-column flex-sm-row justify-content-between align-items-sm-center">
                  <div className="d-flex align-items-center mb-2 mb-sm-0">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center mr-2"
                      style={{
                        width: '34px',
                        height: '34px',
                        backgroundColor: '#EEF2FF',
                        color: '#4F46E5',
                      }}
                    >
                      <FontAwesomeIcon icon={faFilter} size="sm" />
                    </div>
                    <div>
                      <h6 className="font-weight-bold text-dark mb-0">Filtros de Ingresos</h6>
                      <small className="text-muted">Personaliza la visualización y rango de datos</small>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="d-flex align-items-center font-weight-bold mr-2 shadow-sm"
                      onClick={() => clearSearch()}
                    >
                      <FontAwesomeIcon icon={faRedoAlt} className="mr-1" />
                      Limpiar
                    </Button>
                    <Button
                      variant="success"
                      size="sm"
                      className="d-flex align-items-center font-weight-bold shadow-sm"
                      onClick={() => setShowModal(true)}
                    >
                      <FontAwesomeIcon icon={faFileExcel} className="mr-1" />
                      Exportar Excel
                    </Button>
                  </div>
                </div>
                <Card.Body className="p-4">
                  <Form>
                    <Row>
                      <Col xs={12} sm={6} lg={3} className="mb-3">
                        <Form.Group className="mb-0">
                          <Form.Label className="text-muted small text-uppercase font-weight-bold d-flex align-items-center mb-1">
                            <FontAwesomeIcon icon={faLayerGroup} className="mr-1 text-primary" />
                            Diseño / Formato
                          </Form.Label>
                          <Form.Control
                            onChange={(e) => {
                              setDisplay(e.target.value);
                            }}
                            value={display}
                            name="display"
                            as="select"
                            className="rounded"
                          >
                            <option value={DISPLAY_TYPES.ANUAL}>Anual</option>
                            <option value={DISPLAY_TYPES.SIX_MONTHS}>6 meses</option>
                            <option value={DISPLAY_TYPES.HISTORIC}>Histórico</option>
                            <option value={DISPLAY_TYPES.SPECIFIC}>Específico</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} lg={2} className="mb-3">
                        <Form.Group className="mb-0">
                          <Form.Label className="text-muted small text-uppercase font-weight-bold d-flex align-items-center mb-1">
                            <FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-primary" />
                            Año
                          </Form.Label>
                          <Form.Control
                            onChange={(e) => {
                              setYear(e.target.value);
                              setisDollar(false);
                            }}
                            value={year}
                            name="year"
                            as="select"
                            className="rounded"
                            disabled={
                              isLoadingYears ||
                              display === DISPLAY_TYPES.SPECIFIC ||
                              display === DISPLAY_TYPES.SIX_MONTHS ||
                              display === DISPLAY_TYPES.HISTORIC
                            }
                          >
                            {isLoadingYears ? (
                              <option>Cargando...</option>
                            ) : (
                              years.map((yearOption) => (
                                <option value={yearOption} key={yearOption}>
                                  {yearOption}
                                </option>
                              ))
                            )}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} lg={3} className="mb-3">
                        <Form.Group className="mb-0">
                          <Form.Label className="text-muted small text-uppercase font-weight-bold d-flex align-items-center mb-1">
                            <FontAwesomeIcon icon={faCreditCard} className="mr-1 text-primary" />
                            Método de Pago
                          </Form.Label>
                          <Form.Control
                            onChange={(e) => {
                              setPayment(e.target.value);
                              setisDollar(false);
                            }}
                            value={payment}
                            name="Payment"
                            as="select"
                            className="rounded"
                          >
                            <option value="">Todos los métodos</option>
                            <option value="Efectivo">Efectivo</option>
                            <option value="Banco">Banco</option>
                            <option value="Tarjetas">Tarjetas</option>
                            <option value="MercadoPago">MercadoPago</option>
                            <option value="Payway">Payway</option>
                            <option value="Otro">Otro</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>

                      {/* Toggles: Becas & Dólar Histórico */}
                      <Col xs={12} sm={6} lg={4} className="mb-3">
                        <Form.Label className="text-muted small text-uppercase font-weight-bold d-block mb-1">
                          Opciones Adicionales
                        </Form.Label>
                        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                          <div
                            className="d-flex align-items-center justify-content-between bg-light rounded px-3 py-2 border flex-fill"
                            style={{ height: 'calc(1.5em + .75rem + 2px)' }}
                          >
                            <span className="small font-weight-bold text-dark d-flex align-items-center mr-2">
                              <FontAwesomeIcon icon={faGraduationCap} className="mr-1 text-info" />
                              Becas
                            </span>
                            <Form.Check
                              type="switch"
                              id="scolarship-switch"
                              label=""
                              checked={scolarship}
                              onChange={() => {
                                setScolarship(!scolarship);
                                setisDollar(false);
                              }}
                              className="m-0"
                            />
                          </div>

                          <div
                            className="d-flex align-items-center justify-content-between bg-light rounded px-3 py-2 border flex-fill"
                            style={{ height: 'calc(1.5em + .75rem + 2px)' }}
                          >
                            <span
                              className={`small font-weight-bold d-flex align-items-center mr-2 ${
                                display === DISPLAY_TYPES.SPECIFIC ? 'text-muted' : 'text-dark'
                              }`}
                            >
                              <FontAwesomeIcon
                                icon={faDollarSign}
                                className={`mr-1 ${
                                  display === DISPLAY_TYPES.SPECIFIC ? 'text-muted' : 'text-success'
                                }`}
                              />
                              Dólar
                            </span>
                            <Form.Check
                              type="switch"
                              id="dollar-switch"
                              label=""
                              checked={isDollar}
                              disabled={display === DISPLAY_TYPES.SPECIFIC}
                              onChange={(e) => setisDollar(e.target.checked)}
                              className="m-0"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="pt-3 border-top mt-2 align-items-center">
                      <Col xs={12} sm={6} md={4} className="mb-2 mb-md-0">
                        <Form.Group className="mb-0">
                          <Form.Label className="text-muted small text-uppercase font-weight-bold d-flex align-items-center mb-1">
                            <FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-secondary" />
                            Desde
                          </Form.Label>
                          <Form.Control
                            type="date"
                            value={since}
                            onChange={(e) => {
                              setSince(moment(e.target.value).format('YYYY-MM-DD'));
                            }}
                            name="Since"
                            className="rounded"
                            disabled={
                              display === DISPLAY_TYPES.ANUAL ||
                              display === DISPLAY_TYPES.SIX_MONTHS ||
                              display === DISPLAY_TYPES.HISTORIC
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={4} className="mb-2 mb-md-0">
                        <Form.Group className="mb-0">
                          <Form.Label className="text-muted small text-uppercase font-weight-bold d-flex align-items-center mb-1">
                            <FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-secondary" />
                            Hasta
                          </Form.Label>
                          <Form.Control
                            type="date"
                            value={to}
                            onChange={(e) => {
                              setTo(moment(e.target.value).format('YYYY-MM-DD'));
                            }}
                            name="To"
                            className="rounded"
                            disabled={
                              display === DISPLAY_TYPES.ANUAL ||
                              display === DISPLAY_TYPES.SIX_MONTHS ||
                              display === DISPLAY_TYPES.HISTORIC
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={4} className="d-flex align-items-center mt-2 mt-md-4">
                        {display === DISPLAY_TYPES.SPECIFIC ? (
                          <small className="text-primary font-weight-bold">
                            * Mostrando ingresos para el rango de fechas seleccionado.
                          </small>
                        ) : display === DISPLAY_TYPES.HISTORIC ? (
                          <small className="text-primary font-weight-bold">
                            * Mostrando histórico completo. Usa los botones rápidos o el deslizador inferior para hacer zoom.
                          </small>
                        ) : (
                          <small className="text-muted font-italic">
                            * El rango de fechas personalizado se habilita seleccionando diseño <strong>"Específico"</strong>.
                          </small>
                        )}
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
              {isLoading.form ? (
                <Card className="border-0 shadow-sm rounded-lg bg-white p-5 text-center mt-3">
                  <div className="d-flex justify-content-center align-items-center py-4">
                    <Spinner
                      animation="border"
                      role="status"
                      size="md"
                      className="mr-3"
                      variant="primary"
                    />
                    <span className="text-muted font-weight-bold">Cargando métricas e ingresos...</span>
                  </div>
                </Card>
              ) : fetchedData.length !== 0 ? (
                <>
                  <Row className="mt-3 mb-2">
                    <Col lg={3} sm={6} className="mb-3">
                      <Card className="border-0 shadow-sm rounded-lg h-100 bg-white">
                        <Card.Body className="d-flex flex-column justify-content-between p-3">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="text-muted small text-uppercase font-weight-bold text-truncate mr-2">
                              Total Ingresos
                            </span>
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                              style={{
                                width: '38px',
                                height: '38px',
                                backgroundColor: '#ECFDF5',
                                color: '#059669',
                              }}
                            >
                              <FontAwesomeIcon icon={faMoneyBillWave} />
                            </div>
                          </div>
                          <div>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <BSTooltip id="tooltip-total-income">
                                  {formatCurrency.format(summaryMetrics.totalIncome)}
                                </BSTooltip>
                              }
                            >
                              <div
                                className="font-weight-bold mb-1 text-dark text-truncate"
                                style={{ fontSize: '1.28rem', letterSpacing: '-0.02em', cursor: 'pointer' }}
                                title={formatCurrency.format(summaryMetrics.totalIncome)}
                              >
                                {formatCurrency.format(summaryMetrics.totalIncome)}
                              </div>
                            </OverlayTrigger>
                            <small className="text-muted d-block text-truncate">
                              {display === DISPLAY_TYPES.ANUAL
                                ? `Año ${year}`
                                : display === DISPLAY_TYPES.SIX_MONTHS
                                ? 'Últimos 6 meses'
                                : display === DISPLAY_TYPES.HISTORIC
                                ? 'Histórico completo'
                                : 'Período seleccionado'}
                            </small>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={3} sm={6} className="mb-3">
                      <Card className="border-0 shadow-sm rounded-lg h-100 bg-white">
                        <Card.Body className="d-flex flex-column justify-content-between p-3">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="text-muted small text-uppercase font-weight-bold text-truncate mr-2">
                              Ticket Promedio
                            </span>
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                              style={{
                                width: '38px',
                                height: '38px',
                                backgroundColor: '#EEF2FF',
                                color: '#4F46E5',
                              }}
                            >
                              <FontAwesomeIcon icon={faReceipt} />
                            </div>
                          </div>
                          <div>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <BSTooltip id="tooltip-avg-ticket">
                                  {formatCurrency.format(summaryMetrics.averageTicket)}
                                </BSTooltip>
                              }
                            >
                              <div
                                className="font-weight-bold mb-1 text-dark text-truncate"
                                style={{ fontSize: '1.28rem', letterSpacing: '-0.02em', cursor: 'pointer' }}
                                title={formatCurrency.format(summaryMetrics.averageTicket)}
                              >
                                {formatCurrency.format(summaryMetrics.averageTicket)}
                              </div>
                            </OverlayTrigger>
                            <small className="text-muted d-block text-truncate">
                              {summaryMetrics.activePeriodsCount}{' '}
                              {summaryMetrics.activePeriodsCount === 1
                                ? display === DISPLAY_TYPES.HISTORIC || display === DISPLAY_TYPES.SPECIFIC
                                  ? 'mes registrado'
                                  : 'período activo'
                                : display === DISPLAY_TYPES.HISTORIC || display === DISPLAY_TYPES.SPECIFIC
                                ? 'meses registrados'
                                : 'períodos activos'}
                            </small>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={3} sm={6} className="mb-3">
                      <Card className="border-0 shadow-sm rounded-lg h-100 bg-white">
                        <Card.Body className="d-flex flex-column justify-content-between p-3">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="text-muted small text-uppercase font-weight-bold text-truncate mr-2">
                              Cuota 1 (Nuevos)
                            </span>
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                              style={{
                                width: '38px',
                                height: '38px',
                                backgroundColor: '#E0F2FE',
                                color: '#0284C7',
                              }}
                            >
                              <FontAwesomeIcon icon={faGraduationCap} />
                            </div>
                          </div>
                          <div>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <BSTooltip id="tooltip-cuota1">
                                  {display === DISPLAY_TYPES.ANUAL ||
                                  display === DISPLAY_TYPES.HISTORIC ||
                                  display === DISPLAY_TYPES.SPECIFIC
                                    ? formatCurrency.format(summaryMetrics.cuota1Total)
                                    : formatCurrency.format(summaryMetrics.totalIncome)}
                                </BSTooltip>
                              }
                            >
                              <div
                                className="font-weight-bold mb-1 text-dark text-truncate"
                                style={{ fontSize: '1.28rem', letterSpacing: '-0.02em', cursor: 'pointer' }}
                                title={
                                  display === DISPLAY_TYPES.ANUAL ||
                                  display === DISPLAY_TYPES.HISTORIC ||
                                  display === DISPLAY_TYPES.SPECIFIC
                                    ? formatCurrency.format(summaryMetrics.cuota1Total)
                                    : formatCurrency.format(summaryMetrics.totalIncome)
                                }
                              >
                                {display === DISPLAY_TYPES.ANUAL ||
                                display === DISPLAY_TYPES.HISTORIC ||
                                display === DISPLAY_TYPES.SPECIFIC
                                  ? formatCurrency.format(summaryMetrics.cuota1Total)
                                  : formatCurrency.format(summaryMetrics.totalIncome)}
                              </div>
                            </OverlayTrigger>
                            <small className="text-info font-weight-bold d-block text-truncate">
                              {display === DISPLAY_TYPES.ANUAL ||
                              display === DISPLAY_TYPES.HISTORIC ||
                              display === DISPLAY_TYPES.SPECIFIC
                                ? `${summaryMetrics.cuota1Percentage}% del total`
                                : 'Total período'}
                            </small>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={3} sm={6} className="mb-3">
                      <Card className="border-0 shadow-sm rounded-lg h-100 bg-white">
                        <Card.Body className="d-flex flex-column justify-content-between p-3">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="text-muted small text-uppercase font-weight-bold text-truncate mr-2">
                              {display === DISPLAY_TYPES.ANUAL ? 'Otras Cuotas' : 'Mejor Período'}
                            </span>
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                              style={{
                                width: '38px',
                                height: '38px',
                                backgroundColor: '#FEF3C7',
                                color: '#D97706',
                              }}
                            >
                              <FontAwesomeIcon icon={faChartLine} />
                            </div>
                          </div>
                          <div>
                            {display === DISPLAY_TYPES.ANUAL ? (
                              <>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <BSTooltip id="tooltip-otras-cuotas">
                                      {formatCurrency.format(summaryMetrics.otrasCuotasTotal)}
                                    </BSTooltip>
                                  }
                                >
                                  <div
                                    className="font-weight-bold mb-1 text-dark text-truncate"
                                    style={{ fontSize: '1.28rem', letterSpacing: '-0.02em', cursor: 'pointer' }}
                                    title={formatCurrency.format(summaryMetrics.otrasCuotasTotal)}
                                  >
                                    {formatCurrency.format(summaryMetrics.otrasCuotasTotal)}
                                  </div>
                                </OverlayTrigger>
                                <small className="text-muted d-block text-truncate">
                                  {summaryMetrics.otrasCuotasPercentage}% del total
                                </small>
                              </>
                            ) : (
                              <>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <BSTooltip id="tooltip-peak-month">
                                      {summaryMetrics.peakMonth
                                        ? `${summaryMetrics.peakMonth.name}: ${formatCurrency.format(summaryMetrics.peakMonth.amount)}`
                                        : '-'}
                                    </BSTooltip>
                                  }
                                >
                                  <div
                                    className="font-weight-bold mb-1 text-dark text-truncate"
                                    style={{ fontSize: '1.28rem', letterSpacing: '-0.02em', cursor: 'pointer' }}
                                    title={summaryMetrics.peakMonth?.name || '-'}
                                  >
                                    {summaryMetrics.peakMonth?.name || '-'}
                                  </div>
                                </OverlayTrigger>
                                <small className="text-muted font-weight-bold d-block text-truncate">
                                  {summaryMetrics.peakMonth
                                    ? formatCurrency.format(summaryMetrics.peakMonth.amount)
                                    : '-'}
                                </small>
                              </>
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  <Card className="border-0 shadow-sm rounded-lg bg-white overflow-hidden mb-4">
                    <div className="bg-light px-4 py-3 border-bottom d-flex flex-column flex-sm-row justify-content-between align-items-sm-center">
                      <div className="d-flex align-items-center mb-2 mb-sm-0">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center mr-2"
                          style={{
                            width: '34px',
                            height: '34px',
                            backgroundColor: '#ECFDF5',
                            color: '#059669',
                          }}
                        >
                          <FontAwesomeIcon icon={faChartBar} size="sm" />
                        </div>
                        <div>
                          <h6 className="font-weight-bold text-dark mb-0">Evolución de Ingresos</h6>
                          <small className="text-muted">
                            {display === DISPLAY_TYPES.ANUAL
                              ? `Distribución mensual de Cuota 1 y Otras Cuotas (${year})`
                              : display === DISPLAY_TYPES.SIX_MONTHS
                              ? 'Ingresos totales de los últimos 6 meses'
                              : display === DISPLAY_TYPES.HISTORIC
                              ? 'Evolución histórica mensual con área acumulada y control interactivo de zoom'
                              : `Ingresos en rango ${since} al ${to}`}
                          </small>
                        </div>
                      </div>
                      {(display === DISPLAY_TYPES.ANUAL ||
                        display === DISPLAY_TYPES.HISTORIC ||
                        display === DISPLAY_TYPES.SPECIFIC) && (
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center mr-3">
                            <span
                              style={{
                                display: 'inline-block',
                                width: '12px',
                                height: '12px',
                                backgroundColor: '#10B981',
                                borderRadius: '3px',
                                marginRight: '6px',
                              }}
                            />
                            <small className="font-weight-bold text-muted">Cuota 1</small>
                          </div>
                          <div className="d-flex align-items-center">
                            <span
                              style={{
                                display: 'inline-block',
                                width: '12px',
                                height: '12px',
                                backgroundColor: '#6366F1',
                                borderRadius: '3px',
                                marginRight: '6px',
                              }}
                            />
                            <small className="font-weight-bold text-muted">Otras Cuotas</small>
                          </div>
                        </div>
                      )}
                    </div>
                    <Card.Body className="p-4">
                      {display === DISPLAY_TYPES.HISTORIC && (
                        <div
                          className="d-flex flex-wrap align-items-center justify-content-between mb-3 pb-2 border-bottom"
                          style={{ gap: '8px' }}
                        >
                          <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
                            <span className="small text-muted font-weight-bold mr-1">Rango rápido:</span>
                            <Button
                              variant={historicPreset === 'all' ? BUTTON_VARIANTS.PRESET_ACTIVE : BUTTON_VARIANTS.PRESET_INACTIVE}
                              size="sm"
                              className="py-0 px-2 font-weight-bold"
                              style={{ fontSize: '12px', borderRadius: '15px' }}
                              onClick={() => handlePresetRange('all')}
                            >
                              Todo
                            </Button>
                            <Button
                              variant={historicPreset === '12m' ? BUTTON_VARIANTS.PRESET_ACTIVE : BUTTON_VARIANTS.PRESET_INACTIVE}
                              size="sm"
                              className="py-0 px-2 font-weight-bold"
                              style={{ fontSize: '12px', borderRadius: '15px' }}
                              onClick={() => handlePresetRange('12m')}
                            >
                              Últimos 12M
                            </Button>
                            <Button
                              variant={historicPreset === '24m' ? BUTTON_VARIANTS.PRESET_ACTIVE : BUTTON_VARIANTS.PRESET_INACTIVE}
                              size="sm"
                              className="py-0 px-2 font-weight-bold"
                              style={{ fontSize: '12px', borderRadius: '15px' }}
                              onClick={() => handlePresetRange('24m')}
                            >
                              Últimos 24M
                            </Button>
                            <Button
                              variant={historicPreset === '36m' ? BUTTON_VARIANTS.PRESET_ACTIVE : BUTTON_VARIANTS.PRESET_INACTIVE}
                              size="sm"
                              className="py-0 px-2 font-weight-bold"
                              style={{ fontSize: '12px', borderRadius: '15px' }}
                              onClick={() => handlePresetRange('36m')}
                            >
                              Últimos 3 años
                            </Button>
                          </div>
                          <div className="d-flex align-items-center flex-wrap" style={{ gap: '4px' }}>
                            <span className="small text-muted font-weight-bold mr-1">Año:</span>
                            {years.map((yearValue) => (
                              <Button
                                key={yearValue}
                                data-year={yearValue}
                                variant={historicPreset === yearValue ? BUTTON_VARIANTS.YEAR_ACTIVE : BUTTON_VARIANTS.YEAR_INACTIVE}
                                size="sm"
                                className={`py-0 px-2 font-weight-bold text-dark ${
                                  historicPreset === yearValue ? 'text-white' : 'border'
                                }`}
                                style={{ fontSize: '11px', borderRadius: '12px' }}
                                onClick={handleYearPreset}
                              >
                                {yearValue}
                              </Button>
                            ))}
                          </div>
                        </div>
                      )}

                      <div
                        style={{
                          width: '100%',
                          height: display === DISPLAY_TYPES.HISTORIC ? 460 : 420,
                        }}
                      >
                        <ResponsiveContainer width="100%" height="100%">
                          {display === DISPLAY_TYPES.HISTORIC ? (
                            <AreaChart
                              data={getTrimmedGraphicData(graphicData, brushRange.startIndex, brushRange.endIndex)}
                              margin={{ top: 15, right: 30, left: 15, bottom: 10 }}
                            >
                              <defs>
                                <linearGradient id="colorCuota1" x1="0" y1="0" x2="0" y2="1">
                                  <stop offset="5%" stopColor="#10B981" stopOpacity={0.75} />
                                  <stop offset="95%" stopColor="#10B981" stopOpacity={0.05} />
                                </linearGradient>
                                <linearGradient id="colorOtrasCuotas" x1="0" y1="0" x2="0" y2="1">
                                  <stop offset="5%" stopColor="#6366F1" stopOpacity={0.75} />
                                  <stop offset="95%" stopColor="#6366F1" stopOpacity={0.05} />
                                </linearGradient>
                              </defs>
                              <CartesianGrid
                                strokeDasharray="3 3"
                                stroke="#f1f5f9"
                                vertical={false}
                              />
                              <XAxis
                                dataKey="name"
                                stroke="#64748b"
                                fontSize={11}
                                tickLine={false}
                                axisLine={{ stroke: '#e2e8f0' }}
                                minTickGap={18}
                              />
                              <YAxis
                                width={85}
                                tickFormatter={formatCompactCurrency}
                                stroke="#64748b"
                                fontSize={12}
                                tickLine={false}
                                axisLine={{ stroke: '#e2e8f0' }}
                              />
                              <Tooltip content={renderCustomTooltip} />
                              <Area
                                type="monotone"
                                dataKey="OtrasCuotas"
                                fill="url(#colorOtrasCuotas)"
                                stroke="#6366F1"
                                strokeWidth={2}
                                name="Otras cuotas"
                                stackId="a"
                              />
                              <Area
                                type="monotone"
                                dataKey="Cuota1"
                                fill="url(#colorCuota1)"
                                stroke="#10B981"
                                strokeWidth={2}
                                name="Cuota 1"
                                stackId="a"
                              />
                              <Brush
                                dataKey="name"
                                height={34}
                                stroke="#6366F1"
                                fill="#f8fafc"
                                travellerWidth={12}
                                startIndex={0}
                                endIndex={getTrimmedGraphicDataEndIndex(graphicData.length, brushRange.startIndex, brushRange.endIndex)}
                                onChange={handleBrushChange}
                              />
                            </AreaChart>
                          ) : (
                            <BarChart
                              data={graphicData}
                              margin={{ top: 15, right: 30, left: 15, bottom: 20 }}
                              barSize={display === DISPLAY_TYPES.SPECIFIC && graphicData.length <= 2 ? 60 : 32}
                            >
                              <CartesianGrid
                                strokeDasharray="3 3"
                                stroke="#f1f5f9"
                                vertical={false}
                              />
                              <XAxis
                                dataKey="name"
                                stroke="#64748b"
                                fontSize={12}
                                tickLine={false}
                                axisLine={{ stroke: '#e2e8f0' }}
                              />
                              <YAxis
                                width={85}
                                tickFormatter={formatCompactCurrency}
                                stroke="#64748b"
                                fontSize={12}
                                tickLine={false}
                                axisLine={{ stroke: '#e2e8f0' }}
                              />
                              <Tooltip content={renderCustomTooltip} />
                              {display === DISPLAY_TYPES.ANUAL || display === DISPLAY_TYPES.SPECIFIC ? (
                                <>
                                  <Bar
                                    dataKey="OtrasCuotas"
                                    fill="#6366F1"
                                    name="Otras cuotas"
                                    stackId="a"
                                    radius={[0, 0, 0, 0]}
                                  />
                                  <Bar
                                    dataKey="Cuota1"
                                    fill="#10B981"
                                    name="Cuota 1"
                                    stackId="a"
                                    radius={[4, 4, 0, 0]}
                                  />
                                </>
                              ) : (
                                <Bar
                                  dataKey="Total"
                                  name="Total"
                                  fill="#10B981"
                                  radius={[4, 4, 0, 0]}
                                />
                              )}
                            </BarChart>
                          )}
                        </ResponsiveContainer>
                      </div>
                    </Card.Body>
                  </Card>
                </>
              ) : (
                <Card className="border-0 shadow-sm rounded-lg bg-white p-5 text-center mt-3">
                  <div className="text-muted py-4">
                    <FontAwesomeIcon
                      icon={faFilter}
                      size="2x"
                      className="mb-3 text-secondary"
                      style={{ opacity: 0.5 }}
                    />
                    <p className="font-weight-bold mb-1 text-dark">
                      No se encontraron pagos registrados
                    </p>
                    <small className="text-muted">
                      No existen pagos ingresados para el rango de fechas o método de pago seleccionado.
                    </small>
                  </div>
                </Card>
              )}
            </Container>
          </Tab>
          <Tab
            eventKey="comparison"
            title={
              <span className="incomes-tabs-tab-title">
                <FontAwesomeIcon icon={faChartLine} className="incomes-tabs-tab-icon" />
                Comparativa Ventas
              </span>
            }
          >
            {renderComparativaVentas()}
          </Tab>
          <Tab
            eventKey="pending"
            title={
              <span className="incomes-tabs-tab-title">
                <FontAwesomeIcon icon={faFileInvoiceDollar} className="incomes-tabs-tab-icon" />
                Pendientes de Cobro
              </span>
            }
          >
            <PendingCollections />
          </Tab>
        </Tabs>
        </div>
      </>
    );
  } else {
    return <div />;
  }
}
